import {
  activateConsentGatedElements,
  hasMarketingConsent,
  onMarketingConsent,
  requestMarketingConsent,
} from '/Foundation/Common/code/Helpers/CookieConsentHelper.ts';
import '/Foundation/Common/code/Views/Foundation/Common/ConsentPlaceholder.js';

// Matches the Video embed desktop/mobile switch (`d-lg-*`), whose hidden twin is
// skipped by the activation loop and must be picked up when it becomes visible.
const DESKTOP_MQ = '(min-width: 992px)';

const activateAll = (): void => activateConsentGatedElements();

onMarketingConsent(activateAll);
window.matchMedia(DESKTOP_MQ).addEventListener('change', activateAll);

const isYoutubeModal = (target: EventTarget | null): target is HTMLElement =>
  target instanceof HTMLElement && target.matches('.js-youtube-modal');

const getPlaceholder = (modal: HTMLElement): HTMLElement | null => {
  let placeholder = modal.querySelector<HTMLElement>('thule-consent-placeholder');
  if (!placeholder) {
    const body = modal.querySelector('.modal-body');
    if (!body) return null;
    placeholder = document.createElement('thule-consent-placeholder');
    body.appendChild(placeholder);
  }
  return placeholder;
};

// `.js-youtube-modal`: the trigger button carries data-src/data-title, the iframe stays
// empty until consent so the modal can open on the placeholder instead of the player.
document.addEventListener('show.bs.modal', (event) => {
  const modal = event.target;
  if (!isYoutubeModal(modal)) return;
  const iframe = modal.querySelector<HTMLIFrameElement>('iframe');
  if (!iframe) return;

  const trigger = (event as Event & { relatedTarget?: HTMLElement }).relatedTarget;
  const src = trigger?.dataset.src ?? '';
  iframe.dataset.defaultTitle ??= iframe.title;
  iframe.title = trigger?.dataset.title || iframe.dataset.defaultTitle || '';

  const placeholder = getPlaceholder(modal);
  if (hasMarketingConsent()) {
    iframe.src = src;
    iframe.hidden = false;
    if (placeholder) placeholder.hidden = true;
    return;
  }

  iframe.dataset.consentSrc = src;
  iframe.classList.add('js-youtube-embed');
  iframe.hidden = true;
  if (placeholder) placeholder.hidden = false;
});

document.addEventListener('hidden.bs.modal', (event) => {
  const modal = event.target;
  if (!isYoutubeModal(modal)) return;
  const iframe = modal.querySelector<HTMLIFrameElement>('iframe');
  if (iframe) {
    iframe.removeAttribute('src');
    delete iframe.dataset.consentSrc;
    iframe.hidden = true;
  }
  const placeholder = modal.querySelector<HTMLElement>('thule-consent-placeholder');
  if (placeholder) placeholder.hidden = true;
});

window.ThuleCookieConsent = {
  hasMarketingConsent,
  onMarketingConsent,
  requestMarketingConsent,
  activate: activateConsentGatedElements,
};
